module.exports = __webpack_public_path__ + "assets/photos/memories/frame-1--f052b46c4198070e7d5360e431d93ece.jpg";